// Helper function to filter only new file uploads (files without id property)
export const getNewFileUploads = (
  files: Array<{ id?: number }> | undefined
): Array<{ id?: number }> => {
  return files?.filter((file) => !('id' in file)) || []
}
